import { Link, useNavigate, useParams } from 'react-router-dom';
import { CheckCircle, Clock, Image, MessageCircle, Scissors, Settings, Users } from 'lucide-react';
import api from '../utils/api';

const steps = [
  { title: 'Dados e horarios', text: 'Configure endereço, contatos, dias abertos e política de cancelamento.', path: 'configuracoes', icon: Settings },
  { title: 'Servicos', text: 'Cadastre preços, duração, fotos e order bumps.', path: 'servicos', icon: Scissors },
  { title: 'Barbeiros', text: 'Adicione profissionais e WhatsApp de cada um.', path: 'barbeiros', icon: Users },
  { title: 'WhatsApp', text: 'Conecte o WhatsApp Web para notificações automáticas.', path: 'whatsapp', icon: MessageCircle },
  { title: 'Publicacoes', text: 'Adicione stories e fotos para deixar a página pública mais forte.', path: 'publicacoes', icon: Image }
];

export default function OnboardingPage({ onCompleted }) {
  const { id } = useParams();
  const navigate = useNavigate();

  const finish = async () => {
    await api.put(`/barbershops/${id}`, { onboarding_completed: true });
    onCompleted?.();
    navigate(`/dashboard/${id}`);
  };

  return (
    <div className="space-y-6">
      <div className="card overflow-hidden border-primary-500/20">
        <div className="p-6 sm:p-8 bg-gradient-to-br from-primary-950/40 via-dark-800 to-dark-800 border-b border-dark-600">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-3 py-1 text-sm text-primary-200 mb-4">
            <Clock className="w-4 h-4" />
            Configuração inicial
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white">Deixe sua barbearia pronta para vender</h1>
          <p className="text-gray-400 mt-2 max-w-2xl">
            Siga estes passos para publicar sua página, receber agendamentos e automatizar o WhatsApp.
          </p>
        </div>

        <div className="p-6 sm:p-8 grid md:grid-cols-2 gap-4">
          {steps.map((step, index) => (
            <Link key={step.path} to={`/dashboard/${id}/${step.path}`} className="group rounded-xl border border-dark-600 bg-dark-700/40 p-5 hover:border-primary-500/50 transition-all">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-primary-500/10 border border-primary-500/20 flex items-center justify-center">
                  <step.icon className="w-5 h-5 text-primary-300" />
                </div>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Passo {index + 1}</p>
                  <h2 className="font-semibold text-white group-hover:text-primary-200">{step.title}</h2>
                  <p className="text-sm text-gray-400 mt-1">{step.text}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 justify-end">
        <Link to={`/b/${localStorage.getItem('barbershopSlug') || id}`} className="btn-outline">
          Ver pagina publica
        </Link>
        <button onClick={finish} className="btn-primary">
          <CheckCircle className="w-4 h-4 mr-2" />
          Marcar como configurado
        </button>
      </div>
    </div>
  );
}
